"use client"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"
import { Button } from "@/components/ui/button"
import { Icon } from "@/components/ui/icon"
import { cn } from "@/lib/utils"

type BackButtonProps = {
  className?: string
  variant?: "default" | "outline" | "ghost" | "link" | "destructive" | "secondary"
  size?: "default" | "sm" | "lg" | "icon"
  showText?: boolean
}

export function BackButton({ 
  className, 
  variant = "ghost", 
  size = "default",
  showText = false 
}: BackButtonProps) {
  const router = useRouter()
  const t = useTranslations("generic")

  const handleBack = () => {
    router.back()
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleBack}
      className={cn(
        "h-10 w-10 rounded-full p-0 text-primary-foreground hover:bg-primary-foreground/20 transition-all duration-200 hover:scale-105",
        className
      )}
    >
      <Icon 
        icon="lucide:arrow-left" 
        className="h-5 w-5" 
      />
    </Button>
  )
}
